export type ClientLogLevel = 'debug' | 'info' | 'warn' | 'error' | 'fatal';

export const CLIENT_LOG_LEVEL_PRIORITY: Record<ClientLogLevel, number> = {
  debug: 10,
  info: 20,
  warn: 30,
  error: 40,
  fatal: 50,
};

export const isAtLeastLogLevel = (
  level: ClientLogLevel,
  minimumLevel: ClientLogLevel,
): boolean => CLIENT_LOG_LEVEL_PRIORITY[level] >= CLIENT_LOG_LEVEL_PRIORITY[minimumLevel];
